module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('h4', [_vm._v("您的訂購已完成，請至會員中心查詢訂購紀錄")]), _vm._v(" "), _c('center', {
    staticClass: "success_block"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "success_product_title"
  }, [_vm._v("您將獲得免費贈送活動")]), _vm._v(" "), (_vm.firstbuy == 0) ? _c('section', [_c('p', {
    staticClass: "success_description"
  })]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "success_product_name"
  }, [_vm._v(_vm._s(_vm.rowData.name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("\n                        馬上分享 : https://www.i80.com.tw/product/" + _vm._s(_vm.activityItem) + "/" + _vm._s(_vm.UserId) + "\n                      ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.shareLink,
      "title": "i80",
      "description": "i80",
      "hashtags": "i80"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fab fa-facebook fa-2x"
          }), _vm._v(" Facebook\n                          ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "line"
            }
          }, [_c('i', {
            staticClass: "fab fa-line fa-2x"
          }), _vm._v(" Line\n                          ")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#exampleModalCenter"
    }
  }, [_vm._v("\n  了解詳情\n")]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModalCenter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("活動訊息")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n        愛幫您的會員您好，只要按下分享愛幫您將贈送給您免費商品。"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")])])])])]), _vm._v(" "), _c('br')])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("線上訂購")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("訂購完成")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e28bc21a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Success.vue
// module id = 323
// module chunks = 1